import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import "./GymRequestCard.scss";
import { selectIcon, SVG } from "../../UI/selector";
import {
  PostMethod,
  gymLocationList,
  linkGym,
} from "../../../services/CallApi";
import { profileActions } from "../../../store";
import {
  ErrorUI,
  ClosePopup,
  OpenLocationSelectionModal,
} from "../../UI/Modals/Modals";
import ToolTips from "../ToolTips/ToolTips";
import { getData } from "../../../services/CommonFormFunction";
import { CheckValue } from "../../../services/CommonFunction";

const GymRequestCard = ({ gymsArray }) => {
  const dispatch = useDispatch();

  const sendAgainRequest = (gym_id) => {
    ErrorUI(
      "Are you sure you want to request this studio again?",
      () => {
        const gymArray = [...gymsArray];
        const gym = gymArray.filter((el) => el.gym_id === gym_id);
        if (gym.length) {
          const { location_details, membership_code } = gym[0];
          const data = {
            membership_code: membership_code,
            selected_location_ids: CheckValue(location_details)
              ? getData(location_details, "location_id", false)
              : [],
          };
          linkGym(data).then((response) => {
            if (response.status) {
              dispatch(profileActions.updateProfileData(response.data));
              ErrorUI(`Your request has been successfully sent.`);
            } else {
              ErrorUI(response.list);
            }
          });
        } else {
          ErrorUI(`Something is happening try again later.`);
        }
      },
      {
        cancelText: "CANCEL",
        submitText: "CONFIRM",
      }
    );
  };
  const cancelRequest = (gym_id) => {
    const data = {
      gym_id: gym_id,
    };
    ErrorUI(
      "Are you sure you want to cancel this request?",
      () => {
        PostMethod("_cancelGymRequest", data).then((res) => {
          ErrorUI(
            `Your request has been canceled. You can make a request again when you want.`
          );
          dispatch(
            profileActions.updateProfileData({
              pendingGyms: [...gymsArray].filter((el) => el.gym_id !== gym_id),
            })
          );
        });
      },
      {
        cancelText: "CANCEL",
        submitText: "CONFIRM",
      }
    );
  };

  const requests = gymsArray.length
    ? gymsArray.map((el, index) => (
        <GymInfoCard
          key={index}
          gym={el}
          cancelRequest={cancelRequest}
          sendAgainRequest={sendAgainRequest}
        />
      ))
    : [];

  return <React.Fragment>{requests}</React.Fragment>;
};

export const GymInfoCard = ({ gym, cancelRequest, sendAgainRequest }) => {
  const location_details =
    gym.location_details && gym.location_details.length
      ? gym.location_details.filter((el) => el.is_active)
      : [];

  const editLocations = () => {
    gymLocationList({ gym_id: gym.gym_id, limit: 100, offset: 0 }).then(
      (response) => {
        if (response.status) {
          OpenLocationSelectionModal(
            gym.gym_id,
            response.data,
            location_details.length
              ? gym.location_details.map((el) => {
                  return el.location_id;
                })
              : [],
            gym.is_multiple_location_enabled
          );
        } else {
          ErrorUI(response.list, () => editLocations());
        }
      }
    );
  };
  return (
    <div className="GymRequestCard box-layer2">
      <div className="GymProfileInfo">
        <img src={gym.logo_thumb} />
        <p>{gym.name}</p>
      </div>
      <div className="GymRequestCard_footer">
        <div
          className={"GymLocation"}
          onClick={() => {
            if (gym.is_location_enabled) {
              editLocations();
            }
          }}
        >
          {gym.is_location_enabled ? (
            <Fragment>
              <ToolTips
                showTooltip={location_details.length}
                position={"top"}
                overflow={false}
                message={
                  location_details.length
                    ? ListData(location_details, "location_name")
                    : ""
                }
                className={"GymLocation_inside switchable"}
              >
                <SVG
                  height={22}
                  width={22}
                  src={selectIcon("locationPin")}
                  className={"switchable"}
                />
                {location_details.length ? (
                  <span className="list">
                    {location_details.map((el) => el.location_name).join(", ")}
                  </span>
                ) : (
                  `Select Location${
                    gym.is_location_switched_enabled ? "(s)" : ""
                  }`
                )}
              </ToolTips>
            </Fragment>
          ) : null}
        </div>
        {gym.linked_status === 0 ? (
          <button onClick={() => cancelRequest(gym.gym_id)}>Cancel</button>
        ) : null}
        {gym.linked_status === 3 || gym.linked_status === 2 ? (
          <Fragment>
            <button
              className="btns-primary"
              onClick={() => sendAgainRequest(gym.gym_id)}
            >
              Get Access
            </button>
            <div className="divider"></div>
            <div className="info">
              <p>You have been removed from the studio</p>
              <ToolTips
                showTooltip={true}
                position={"top"}
                overflow={false}
                message={`<div class="rejection_reason">
    <span>Reason</span>
    <p class="text">${
      gym.linked_status === 3
        ? gym.removal_comment
        : gym.linked_status === 2
        ? gym.rejection_comment
        : ""
    }</p>
  </div>`}
              >
                <SVG height={22} width={22} src={selectIcon("info")} />
              </ToolTips>
            </div>
          </Fragment>
        ) : null}
      </div>
    </div>
  );
};

export default GymRequestCard;

GymRequestCard.propTypes = {
  gymsArray: PropTypes.array,
};

GymRequestCard.defaultProps = {
  gymsArray: [],
};

const ListData = (data, keyName) => {
  let temp = "<ul>";
  data.forEach((element) => {
    temp += `<li>${element[keyName]}</li>`;
  });
  temp += "</ul>";
  return temp;
};
